import { LicenseInfo } from '@mui/x-license';

const initLicense = () => {
    LicenseInfo.setLicenseKey('1c3043bb334ec088b891af4e53606010Tz05Nzk4MyxFPTE3NTc3Mzc0MzgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg==');
}

export default initLicense;